export const API_BASE_URL = 'https://api.shmnext.com' //@TODO change this to process.env using webpack
